module.exports = __webpack_public_path__ + "img/image168.561d6f2a.jpg";